/// <reference path="../../_ext/editors/BOMGridEditor.ts" />
namespace TabAurous.Inventory {
    import fld = MaterialRequestBOMRow.Fields;

    @Serenity.Decorators.registerClass()
    export class MaterialRequestBOMEditor extends _Ext.BOMGridEditor<MaterialRequestBOMRow> { 
        protected getDialogType() { return MaterialRequestBOMDialog; }
        protected getLocalTextPrefix() { return MaterialRequestBOMRow.localTextPrefix; } 
        constructor(container: JQuery) {
            super(container);
            this.slickContainer.on('change', '.edit:input', (e) => this.inputsChange(e));            
        } 
    }
}